import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "body", "type", "targetId", "delay", "header", "cleanUpOnUnmount"];
/* eslint-disable import/no-extraneous-dependencies  */
/* eslint-disable react/jsx-props-no-spreading  */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import uuidv5 from 'uuid/v5';
import { NAMESPACE } from './DynamicScript.constants';
import { iifeWrapper, getAdditionalScriptProps } from './DynamicScript.utils';
import { isDocumentDefined } from '../../utils/dom';
var defaultProps = {
  src: null,
  body: null,
  type: null,
  targetId: null,
  delay: null,
  header: false,
  cleanUpOnUnmount: true
};
export default function DynamicScript(_ref) {
  var src = _ref.src,
    body = _ref.body,
    type = _ref.type,
    targetId = _ref.targetId,
    delay = _ref.delay,
    header = _ref.header,
    cleanUpOnUnmount = _ref.cleanUpOnUnmount,
    rest = _objectWithoutProperties(_ref, _excluded);
  var scriptContainerId = uuidv5(src || body, NAMESPACE);
  var mainContainer = /*#__PURE__*/React.createElement("div", {
    id: scriptContainerId
  });
  if (!isDocumentDefined()) return mainContainer;
  function scriptAlreadyExist(scriptContainer) {
    if (!scriptContainer) {
      return false;
    }
    return !!scriptContainer.firstChild;
  }
  function loadScript() {
    var scriptContainer = document.getElementById(scriptContainerId);
    var script = null;
    if (scriptAlreadyExist(scriptContainer)) return null;
    script = document.createElement('script');
    if (src) script.src = src;
    if (body) script.innerHTML = iifeWrapper(body);
    if (type) script.type = type;
    var attrKeys = Object.keys(rest);
    if (attrKeys.length !== 0) {
      attrKeys.forEach(function (key) {
        if (key in rest) script.setAttribute(key, rest[key]);
      });
    }
    if (scriptContainer) scriptContainer.appendChild(script);
    if (targetId) document.getElementById(targetId).appendChild(scriptContainer);
    return scriptContainer;
  }
  function removeScriptNode(scriptNode) {
    if (!scriptNode) return;
    scriptNode.removeChild(scriptNode.firstChild);
    scriptNode.remove();
  }
  useEffect(function () {
    var scriptNode = null;
    if (delay) {
      setTimeout(function () {
        scriptNode = loadScript();
      }, delay);
    } else scriptNode = loadScript();
    if (cleanUpOnUnmount) {
      return function cleanup() {
        removeScriptNode(scriptNode);
      };
    }
    return null;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, src && /*#__PURE__*/React.createElement("script", _extends({
    type: type,
    src: src
  }, getAdditionalScriptProps(rest))), body && /*#__PURE__*/React.createElement("script", _extends({
    type: type
  }, getAdditionalScriptProps(rest)), body)), !header && mainContainer);
}
DynamicScript.defaultProps = defaultProps;